import type { Metric } from '../types/content';

export const impactMetrics: Metric[] = [
  {
    value: '~50%',
    label: 'Operating Model Optimization',
    description: 'Led strategic outsourcing redesign delivering an ~50% reduction in fixed operating costs.'
  },
  {
    value: '20+',
    label: 'International Reach',
    description:
      'Expanded commercial footprint across 20+ global markets spanning Europe, North America, Latin America, and Asia.'
  },
  {
    value: 'Hundreds',
    label: 'Deal Execution',
    description:
      'Negotiated hundreds of international commercial agreements with telecommunications operators, global digital platforms, and enterprise partners.'
  },
  {
    value: '\u20ACM+',
    label: 'Financial Oversight',
    description: 'Direct stewardship of multi-million-euro annual operating budgets, P&L management, and capital allocation.'
  }
];
